// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { variantButtonsStyles } from "@turnerBlueprint/Overrides/Widgets/ProductDetails/ProductDetailsVariantButton";
import { fontConfig } from "@turnerBlueprint/XDL/PreStyle/typography";
import { color, xScreen } from "@turnerBlueprint/XDL/Utilities";
import { css } from "styled-components";

variantButtonsStyles.wrapper = {
    css: css`
        margin-bottom: 16px;
    `,
};

variantButtonsStyles.buttonsWrapper = {
    css: css`
        display: grid;
        grid-template-columns: 1fr 1fr 1fr 1fr;
        gap: 4px;
        margin-top: 8px;

        ${xScreen("lt", "md")} {
            grid-template-columns: 1fr 1fr 1fr;
        }
    `,
};

variantButtonsStyles.labelText = {
    size: 12,
    lineHeight: "14px",
    weight: fontConfig.weight.bold,
};

variantButtonsStyles.link = {
    typographyProps: {
        size: 12,
    },
    css: css`
        white-space: nowrap;
        margin-left: 8px;

        ${TypographyStyle} {
            line-height: 14px;
        }
    `,
};

variantButtonsStyles.button = {
    sizeVariant: "small",
    css: css`
        min-height: 24px;
        max-width: 100%;
        overflow: hidden;
        
        ${TypographyStyle} {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }

        &[disabled] {
            opacity: 1;
            border-color: ${color("common.ui3")};
            &, ${TypographyStyle} {
                color: ${color("common.ui3")};
            }
        }

        ${({ buttonType }: any) =>
            buttonType === "solid" &&
            css`
                background-color: ${color("common.ui10")};
                border-color: ${color("common.ui10")};
            `}
    `,
};
